import { ThemeUICSSObject } from '@apia/theme';
import infoBox from './boxes/infoBox';
import labelBox from './boxes/labelBox';
import selectBox from './boxes/selectBox';
import switchBox from './boxes/switchBox';

const boxes: ThemeUICSSObject = {
  infoBox,
  labelBox,
  selectBox,
  switchBox,
};

export default boxes;
